import React from 'react';
import { motion } from 'framer-motion';
import { Zap, ShieldCheck, Lock, CreditCard, Clock, Check, AlertTriangle } from 'lucide-react';
import { Countdown } from './Countdown';
export function FinalCTA() {
  return <section className="py-14 bg-petroleum relative overflow-hidden border-t border-electric/20" data-id="element-230">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[800px] bg-radial-glow pointer-events-none opacity-40" data-id="element-231"></div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-232">
        {/* Framed Countdown Header */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="relative max-w-3xl mx-auto mb-10" data-id="element-233">
          <div className="absolute -inset-1 bg-gradient-to-r from-red-500 via-red-400 to-red-500 rounded-3xl blur-xl opacity-25 animate-pulse" data-id="element-234"></div>
          <div className="relative bg-gradient-to-br from-graphite via-petroleum to-graphite border-2 border-red-500 rounded-3xl p-8 md:p-10 text-center overflow-hidden shadow-2xl shadow-red-500/20" data-id="element-235">
            <div className="absolute inset-0 opacity-[0.08] pointer-events-none" style={{
            backgroundImage: 'linear-gradient(rgba(239,68,68,0.6) 1px, transparent 1px), linear-gradient(90deg, rgba(239,68,68,0.6) 1px, transparent 1px)',
            backgroundSize: '24px 24px'
          }} data-id="element-236"></div>
            <div className="absolute top-0 left-0 w-14 h-14 border-t-4 border-l-4 border-red-500 rounded-tl-3xl pointer-events-none" data-id="element-237"></div>
            <div className="absolute top-0 right-0 w-14 h-14 border-t-4 border-r-4 border-red-500 rounded-tr-3xl pointer-events-none" data-id="element-238"></div>
            <div className="absolute bottom-0 left-0 w-14 h-14 border-b-4 border-l-4 border-red-500 rounded-bl-3xl pointer-events-none" data-id="element-239"></div>
            <div className="absolute bottom-0 right-0 w-14 h-14 border-b-4 border-r-4 border-red-500 rounded-br-3xl pointer-events-none" data-id="element-240"></div>

            <div className="relative z-10" data-id="element-241">
              <div className="inline-flex items-center gap-2 bg-red-500 text-white px-4 py-1.5 rounded-full text-xs font-extrabold uppercase tracking-wider mb-5 shadow-lg shadow-red-500/40" data-id="element-242">
                <AlertTriangle className="w-3.5 h-3.5" strokeWidth={2.5} data-id="element-243" />
                Última oportunidad
              </div>
              <h2 className="text-2xl md:text-4xl font-extrabold leading-tight mb-5" data-id="element-244">
                <span className="text-white" data-id="element-245">El precio </span>
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-red-400 via-red-300 to-red-400 drop-shadow-[0_0_12px_rgba(239,68,68,0.4)]" data-id="element-246">
                  cierra en:
                </span>
              </h2>
              <Countdown data-id="element-247" />
              <div className="mt-5 mx-auto h-px w-32 bg-gradient-to-r from-transparent via-red-500 to-transparent opacity-70" data-id="element-248"></div>
            </div>
          </div>
        </motion.div>

        <div className="max-w-4xl mx-auto grid md:grid-cols-2 gap-6 mb-8" data-id="element-249">
          {/* Basic Plan Mini */}
          <div className="bg-graphite border border-white/10 rounded-2xl p-6 text-center hover:border-electric/30 transition-all" data-id="element-250">
            <h3 className="text-xl font-bold mb-2" data-id="element-251">
              📘 KIT ELECTRICIDAD EN CASA
            </h3>
            <p className="text-sm text-textsecondary mb-4" data-id="element-252">
              6 Tomos + 6 Bonos · De 0 a Diagnosticador Pro
            </p>
            <div className="mb-6" data-id="element-253">
              <span className="text-textsecondary line-through text-sm mr-2" data-id="element-254">
                $59.000
              </span>
              <span className="text-3xl font-extrabold text-white" data-id="element-255">
                $19.990{' '}
                <span className="text-lg text-textsecondary font-medium" data-id="element-256">
                  ARS
                </span>
              </span>
            </div>
            <a href="https://www.bibliotecasdigitales.store/checkouts/cn/hWNBtdqfmZw6mycXp8XOqb90/es-ar?_r=AQABgnNpXVO1rI1txCBQNxGb_YcTrUPiJJDRD8WaZPPvwao&cart_link_id=NRLX8ejE&preview_theme_id=154123698339" target="_blank" rel="noopener noreferrer" className="group relative w-full bg-gradient-to-r from-petroleum to-petroleum/80 hover:from-electric/20 hover:to-electric/10 border border-electric/50 hover:border-electric text-white font-bold py-3 rounded-xl transition-all duration-300 flex items-center justify-between gap-2 pl-3 pr-2 shadow-md hover:shadow-lg hover:shadow-electric/20" data-id="element-257">
              <span className="flex-shrink-0 w-7 h-7 rounded-lg bg-electric/15 border border-electric/30 flex items-center justify-center group-hover:bg-electric/25 transition-colors" data-id="element-258">
                <Zap className="w-3.5 h-3.5 text-electric fill-electric" data-id="element-259" />
              </span>
              <span className="flex-1 text-center text-sm tracking-wide" data-id="element-260">
                QUIERO MI KIT
              </span>
              <span className="flex-shrink-0 w-7 h-7 rounded-lg bg-electric/15 text-electric flex items-center justify-center group-hover:translate-x-0.5 transition-transform" data-id="element-261">
                <Check className="w-3.5 h-3.5" strokeWidth={3} data-id="element-262" />
              </span>
            </a>
          </div>

          {/* Pro Plan Mini */}
          <div className="bg-gradient-to-b from-[#1a2642] to-petroleum border-2 border-electric rounded-2xl p-6 text-center relative glow-electric" data-id="element-263">
            <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-gold text-graphite font-bold px-3 py-0.5 rounded-full text-xs flex items-center gap-1" data-id="element-264">
              <Zap className="w-3 h-3 fill-graphite" data-id="element-265" /> MÁS POPULAR
            </div>
            <h3 className="text-xl font-bold mb-2 text-gold" data-id="element-266">
              🏆 KIT + EMPRENDEDOR
            </h3>
            <p className="text-sm text-textsecondary mb-4" data-id="element-267">
              6 Tomos + 6 Bonos + Manual del Emprendedor
            </p>
            <div className="mb-6" data-id="element-268">
              <span className="text-textsecondary line-through text-sm mr-2" data-id="element-269">
                $84.000
              </span>
              <span className="text-3xl font-extrabold text-white" data-id="element-270">
                $27.990{' '}
                <span className="text-lg text-textsecondary font-medium" data-id="element-271">
                  ARS
                </span>
              </span>
            </div>
            <a href="https://www.bibliotecasdigitales.store/checkouts/cn/hWNCB1t6C5s5RgTjBwJ8umOI/es-ar?_r=AQAB9DFWSCQ9uktbQXOvjBIdiLEwPNiO56Nua-BL3iqHWuc&cart_link_id=rOf57Ybc&preview_theme_id=154708803747" target="_blank" rel="noopener noreferrer" className="group relative w-full bg-gradient-to-r from-gold/90 to-gold hover:from-yellow-300 hover:to-yellow-400 border border-yellow-200 text-graphite font-bold py-3 rounded-xl transition-all duration-300 flex items-center justify-between gap-2 pl-3 pr-2 shadow-md hover:shadow-lg hover:shadow-gold/40" data-id="element-272">
              <span className="flex-shrink-0 w-7 h-7 rounded-lg bg-graphite/15 border border-graphite/20 flex items-center justify-center" data-id="element-273">
                <Zap className="w-3.5 h-3.5 text-graphite fill-graphite" data-id="element-274" />
              </span>
              <span className="flex-1 text-center text-sm tracking-wide" data-id="element-275">
                QUIERO EL KIT + EMPRENDEDOR
              </span>
              <span className="flex-shrink-0 w-7 h-7 rounded-lg bg-graphite text-gold flex items-center justify-center group-hover:translate-x-0.5 transition-transform" data-id="element-276">
                <Check className="w-3.5 h-3.5" strokeWidth={3} data-id="element-277" />
              </span>
            </a>
          </div>
        </div>

        {/* Trust Row */}
        <div className="flex flex-wrap items-center justify-center gap-6 md:gap-12 text-sm text-textsecondary font-medium" data-id="element-278">
          <div className="flex items-center gap-2" data-id="element-279">
            <Lock className="w-5 h-5 text-electric" data-id="element-280" /> Pago 100% seguro
          </div>
          <div className="flex items-center gap-2" data-id="element-281">
            <Clock className="w-5 h-5 text-electric" data-id="element-282" /> Acceso en 5 minutos
          </div>
          <div className="flex items-center gap-2" data-id="element-283">
            <ShieldCheck className="w-5 h-5 text-electric" data-id="element-284" /> Garantía 7 días
          </div>
          <div className="flex items-center gap-2" data-id="element-285">
            <CreditCard className="w-5 h-5 text-electric" data-id="element-286" /> Mercado Pago —
            Tarjeta — Transferencia
          </div>
        </div>
      </div>
    </section>;
}